import { formatDateAndTime } from 'lib/helpers/utility';

export const cols = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  { field: 'name', headerName: 'Name', minWidth: 100 },
  { field: 'path', headerName: 'Path' },
  { field: 'host', headerName: 'Host' },
  { field: 'version', headerName: 'Version' },
  {
    field: 'created_at',
    headerName: 'Created At',
    valueFormatter: ({ value }) => formatDateAndTime(value)
  }
];

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: false
};
export const GRID_OPTIONS = {
  animateRows: true,
  rowGroupPanelShow: 'never',
  enableRangeSelection: true,
  // showOpenedGroup: true,
  suppressAggFuncInHeader: true,
  autoGroupColumnDef: {
    pinned: 'left',
    sortable: false
  }
};
